import axios from "axios";
import {URL_PREFIX} from "../config";

export const getAllGalleryArtists = (page = 1, page_size = 100) => {
    const params = {
        page: page,
        page_size: page_size
    }
    return axios.get(URL_PREFIX + '/user-gallery-artists/', {
        params
    })
}